import { BookingTreeActionType } from "models/actionTypes/bookingTreeActionTypes";
import { ReduxConstants } from "utils/constants";
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";

export const resetBookingTree = (): BookingTreeActionType => {
  return {
    type: ReduxConstants.BookingTreeActions.RESET_BOOKING_TREE_STATE,
  };
};

export const addBookingTipSuggestion = (
  invoiceId: number,
  suggestions: WintSuperkollAPIModel.IncomingInvoiceBookingTreeItem[]
): BookingTreeActionType => {
  return {
    type: ReduxConstants.BookingTreeActions.ADD_BOOKING_TIP_SUGGESTION,
    payload: {
      invoiceId,
      suggestions,
    },
  };
};

export const setBookingTreeItems = (
  items: WintSuperkollAPIModel.IncomingInvoiceBookingTreeItem[]
): BookingTreeActionType => {
  return {
    type: ReduxConstants.BookingTreeActions.SET_BOOKING_TREE_ITEMS,
    payload: items,
  };
};
